import { useEffect, useState } from 'react';

import { getCrewMember } from '@shared/crew-members/endpoints/getCrewMember';

type CrewMember = App.Domain.CrewMember.Data.CrewMemberData;

export function useFetchCrewMember(id: number | null) {
  const [crewMember, setCrewMember] = useState<CrewMember | null>(null);

  useEffect(() => {
    if (id) {
      getCrewMember({ id }).then((response) => {
        setCrewMember(response);
      });
    } else {
      setCrewMember(null);
    }
  }, [id]);

  return crewMember;
}
